export enum ScopeKey {
   view = 'view',
   create = 'create',
   update = 'update',
   delete = 'delete',
   viewAny = 'view-any',
   permissions = 'permissions',
   admin = 'admin',
   impersonate = 'impersonate',
   needsUpdate = 'needs-update',
   planningsUpdate = 'plannings-update',
   puzzle = 'puzzle',
   manageCandidatePools = 'manage-candidate-pools',
   performances = 'performances',
   communications = 'communications',
}
